var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-center"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("BLUEFIN"),_c('span',{staticClass:"caption"},[_vm._v("FISH DEALER")])]),_c('br'),_c('span',{staticClass:"caption"},[_vm._v(" STALL#623, NEW TAGUM PUBLIC MARKET, TAGUM CITY")])])])
}]

export { render, staticRenderFns }